import {
  FRIENDSHIP_GOALS,
  GENDER_OPTIONS,
  LANGUAGE_OPTIONS,
  POLITICS_OPTIONS,
  RELIGION_OPTIONS,
} from "@/constants/options";
import i18n, { type TranslationKey } from "@/i18n";

const INTEREST_KEYS: Record<string, TranslationKey> = {
  coffee: "profile.interests.coffee",
  food: "profile.interests.food",
  music: "profile.interests.music",
  movies: "profile.interests.movies",
  books: "profile.interests.books",
  gaming: "profile.interests.gaming",
  fitness: "profile.interests.fitness",
  running: "profile.interests.running",
  hiking: "profile.interests.hiking",
  travel: "profile.interests.travel",
  art: "profile.interests.art",
  photography: "profile.interests.photography",
  technology: "profile.interests.technology",
  startups: "profile.interests.startups",
  fashion: "profile.interests.fashion",
  cooking: "profile.interests.cooking",
  dancing: "profile.interests.dancing",
  sports: "profile.interests.sports",
  volunteering: "profile.interests.volunteering",
  languages: "profile.interests.languages",
  other: "profile.interests.other",
};

function optionLabel(
  value: string,
  options: { value: string; label: string }[],
) {
  return options.find((option) => option.value === value)?.label ?? value;
}

export function interestLabel(value: string) {
  const key = INTEREST_KEYS[value.toLowerCase()];
  return key ? i18n.t(key) : value;
}

export function friendshipGoalLabel(value: string) {
  return optionLabel(value, FRIENDSHIP_GOALS);
}

export function languageLabel(value: string) {
  return optionLabel(value, LANGUAGE_OPTIONS);
}

export function genderLabel(value: string) {
  return optionLabel(value, GENDER_OPTIONS);
}

export function religionLabel(value: string) {
  return optionLabel(value, RELIGION_OPTIONS);
}
export function politicsLabel(value: string) {
  return optionLabel(value, POLITICS_OPTIONS);
}

export function profileListText(
  values: (string | null | undefined)[] | null | undefined,
  labeler: (value: string) => string,
  options?: { limit?: number; separator?: string },
) {
  const clean =
    values?.filter((value): value is string => Boolean(value)) ?? [];
  return clean
    .slice(0, options?.limit)
    .map(labeler)
    .join(options?.separator ?? " · ");
}
